// UserModal.js
import React from 'react';
import './DocumentsModal.css';

const DocumentsModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="documents-modal">
      <div className="documents-modal-content">
        <h2 className='documents-title'>Documents Modal</h2>
        {/* Add your modal content here */}
        <button onClick={onClose}>Close Modal</button>
      </div>
    </div>
  );
};

export default DocumentsModal;
